/*
 * Copyright (c) 2018 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 *
 *Description:
*/
export var TRUSTEER_INITIALIZE = 'TRUSTEER_INITIALIZE';
export var TRUSTEER_SET_CONTEXT = 'TRUSTEER_SET_CONTEXT';
export var NUDATA_DETECT_FRAUD = 'NUDATA_DETECT_FRAUD';
export var initializeTrusteer = function initializeTrusteer(payload) {
  return {
    type: TRUSTEER_INITIALIZE,
    payload: payload
  };
};
export var setTrusteerContext = function setTrusteerContext(context) {
  return {
    type: TRUSTEER_SET_CONTEXT,
    context: context
  };
};
export var nudataDetectFraud = function nudataDetectFraud(payload) {
  return {
    type: NUDATA_DETECT_FRAUD,
    payload: payload
  };
};